<template>
  <transition
    :name="'imbee-' + bubble.bubbleTransition"
    :enter-active-class="'imbee-' + bubble.bubbleInTransition"
    :leave-active-class="'imbee-' + bubble.bubbleOutTransition"
    v-on:after-enter="
      () => {
        showBadges = true;
      }
    "
    v-on:before-leave="
      () => {
        showBadges = false;
      }
    "
  >
    <div
      class="w-imbee-bubble"
      v-show="bubble.show"
      :data-opened="opened"
      @click="clicked"
      :style="{
        bottom: bubble.verticalPadding,
        [alignment]: bubble.horizontalPadding,
        color: bubble.color,
        backgroundColor: bubble.backgroundColor,
      }"
    >
      <TextBadge
        :opened="opened"
        :show="textBadge.show && showBadges"
        :text="textBadge.text"
        :color="textBadge.color"
        :background-color="textBadge.backgroundColor"
        :font-size="textBadge.fontSize"
        :font-family="textBadge.fontFamily"
        :font-weight="textBadge.fontWeight"
        :show-cta="showCta"
        :animation="textBadge.animation"
      />
      <CloseCross
        @crossclicked.once="handleCrossClicked"
        :opened="opened"
        :show="closeCross.show"
        :color="closeCross.color"
        :background-color="closeCross.backgroundColor"
        :font-size="closeCross.fontSize"
        :font-family="closeCross.fontFamily"
        :font-weight="closeCross.fontWeight"
        :show-cta="showCta"
        :size="closeCross.size"
        :top="closeCross.top"
        :right="closeCross.right"
      />
      <Badge
        :show="badge.show && showBadges"
        :text="badge.text"
        :color="badge.color"
        :background-color="badge.backgroundColor"
      />
      <transition name="imbee-fade" mode="out-in">
        <div
          v-if="bubble.showImage && !opened"
          class="w-imbee-bubble-image-container"
        >
          <img :src="bubble.image" alt="Chat image" />
        </div>
        <svg
          v-else-if="!opened"
          width="37.973"
          viewBox="0 0 841.89 749.55"
          height="42"
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          key="open"
        >
            <path
                fill="currentColor"
                d="M485.005 655.933H49.375s30.635-9.693 61.269-49.635C141.666 566.36 172.3 496.162 172.3 374.78c0-155.501 126.041-281.163 281.152-281.163h32.441-14.24c155.278 0 281.154 125.888 281.154 281.163 0 155.274-125.876 281.152-281.154 281.152M336.84 330.918c-24.781 0-44.853 20.081-44.853 44.854 0 24.771 20.071 44.854 44.853 44.854 24.771 0 44.843-20.083 44.843-44.854 0-24.773-20.072-44.854-44.843-44.854zm124.834 0c-24.769 0-44.851 20.081-44.851 44.854 0 24.771 20.083 44.854 44.851 44.854 24.772 0 44.854-20.083 44.854-44.854-.001-24.773-20.082-44.854-44.854-44.854zm127.26 0c-24.773 0-44.854 20.081-44.854 44.854 0 24.771 20.08 44.854 44.854 44.854 24.768 0 44.851-20.083 44.851-44.854-.001-24.773-20.084-44.854-44.851-44.854z"
            />
        </svg>
        <Close1 v-if="opened && bubble.closeIcon == 1" />
        <Close2 v-if="opened && bubble.closeIcon == 2" />
        <Close3 v-if="opened && bubble.closeIcon == 3" />
      </transition>
    </div>
  </transition>
</template>

<script>
import Close1 from "../icons/Close1";
import Close2 from "../icons/Close2";
import Close3 from "../icons/Close3";
import Badge from "./Badge";
import CloseCross from "./CloseCross.vue";
import TextBadge from "./TextBadge";

export default {
  name: "Bubble",
  components: {
    Close1,
    Close2,
    Close3,
    Badge,
    TextBadge,
    CloseCross
  },
  props: {
    opened: { type: Boolean, default: false },
    bubble: { type: Object, default:{} },
    badge: { type: Object, default: {} },
    textBadge: { type: Object, default: {} },
    closeCross: { type: Object, default: {}},
    alignment: { type: String, default: "right" },
    showCta: { type: Boolean, default: false },
    color: { type: String, default: "#000" },
    backgroundColor: { type: String, default: "#FFF" },

  },
  data() {
    return {
      showBadges: false,
    };
  },
  methods: {
    clicked() {
      this.$emit("clicked");
    },

    handleCrossClicked() {
      this.bubble.show = false;

      //this.$emit("crossclicked");
    }
    
  },
};
</script>

<style scoped>
.w-imbee-bubble-image-container {
  display: -webkit-box; 
  display: -moz-box; 
  display: -ms-flexbox; 
  display: -webkit-flex; 
  display: flex; 
  overflow: hidden;
  justify-content: center;
  align-items: center;
  height: 54px;
  width: 54px;
  border-radius: 50%;
}

.w-imbee-bubble-image-container > img {
  position: relative;
  width: 100%;
  height: auto;
}

.w-imbee-bubble {
  overflow: visible;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 0;
  text-align: center;
  display: -webkit-box; 
  display: -moz-box; 
  display: -ms-flexbox; 
  display: -webkit-flex; 
  display: flex; 
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0px;
  right: 0px;
  box-shadow: 0 0 15px 0 rgba(136, 136, 136, 0.35);
  transition: all 0.25s ease-out;
  z-index: 2147483647;
  background-color: red;
  color: yellow;
}

.w-imbee-bubble:hover {
  box-shadow: 0 0 15px 0 rgba(136, 136, 136, 0.15),
    0 0 20px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transform: translateY(-2px);
}

@media screen and (max-width: 568px) {
  .w-imbee-bubble[data-opened="true"] {
    display: none !important;
  }
}

@-webkit-keyframes imbee-fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes imbee-fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@-webkit-keyframes imbee-fadeOut {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.9);
  }
}

@keyframes imbee-fadeOut {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.9);
  }
}

.imbee-fade-enter-active,
.imbee-fadeIn,
.imbee-fade-leave-active,
.imbee-fadeOut {
  -webkit-animation-duration: 0.2s;
  animation-duration: 0.2s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.imbee-fade-enter-active,
.imbee-fadeIn {
  -webkit-animation-name: "imbee-fadeIn";
  animation-name: "imbee-fadeIn";
}

.imbee-fade-leave-active,
.imbee-fadeOut {
  -webkit-animation-name: "imbee-fadeOut";
  animation-name: "imbee-fadeOut";
}
</style>



// WEBPACK FOOTER //
// Bubble.vue?edb10186